export const weddingVideos = [
	{ id: 1, title: 'Wedding Film 1', url: 'https://youtu.be/yYfsPBJ5n_8?si=8ghO5YrApqgpJJ-p' },
	{ id: 2, title: 'Wedding Film 2', url: 'https://youtu.be/IsNzYsM3Z3c?si=Dkyha0J6wwWQcbtZ' },
	{ id: 3, title: 'Wedding Film 3', url: 'https://youtu.be/R8bktBWOe_4?si=ex-RUa6ifvJBhj0N' },
	{ id: 4, title: 'Wedding Film 4', url: 'https://youtu.be/N3FvIDyFD5Y?si=f_UybXfgXtADIequ' },
	{ id: 5, title: 'Wedding Film 5', url: 'https://youtu.be/-NnuFhPAvNM?si=3MX1vwN3P8j2sxM9' },
	{ id: 6, title: 'Wedding Film 6', url: 'https://youtu.be/IU9JsVdPvQY?si=XSYfWI_nmpHtJACh' },
	{ id: 7, title: 'Wedding Film 7', url: 'https://youtu.be/uH_gMKygzIM?si=tQVM3U3_SFLp-mNq' },
	{ id: 8, title: 'Wedding Film 8', url: 'https://youtu.be/lodTVVbtdB8?si=7ZQPGVlZ6Zleglwg' },
	{ id: 9, title: 'Wedding Film 9', url: 'https://youtu.be/jH1L5cmQDhI?si=7gesjRum8_NThptI' }
];

export const preweddingVideos = [
	{ id: 1, title: 'Pre Wedding 1', url: 'https://youtu.be/iTzSglBIT5I?si=EqsjH-9s9xM96dNn' },
	{ id: 2, title: 'Pre Wedding 2', url: 'https://youtu.be/nW5SWK6Tuoc?si=4gE6wuFo4RU6LdnB' },
	{ id: 3, title: 'Pre Wedding 3', url: 'https://youtu.be/7psqwbJiiK8?si=pTaA9ktJlrTepMHN' },
	{ id: 4, title: 'Pre Wedding 4', url: 'https://youtu.be/71ji4kIiPxc?si=343eFlS8hbSMSAef' },
	{ id: 5, title: 'Pre Wedding 5', url: 'https://youtu.be/EX9_cQIa70Y?si=bbYYUZ8lnRt-U1-p' },
	{ id: 6, title: 'Pre Wedding 6', url: 'https://youtu.be/iuelRAcDiHo?si=BArV3P9acgAMhEMj' },
	{ id: 7, title: 'Pre Wedding 7', url: 'https://youtu.be/omAAf5nJ7MU?si=469m3g1pmINmLAJK' },
	{ id: 8, title: 'Pre Wedding 8', url: 'https://youtu.be/5iHCAachtY8?si=ZyDDw7d5g2Yvvf8q' },
	{ id: 9, title: 'Pre Wedding 9', url: 'https://youtu.be/7ydJ9LqyV0A?si=z40zllkXwEXtcw7Q' },
	{ id: 10, title: 'Pre Wedding 10', url: 'https://youtu.be/W8V79mm5fp0?si=n02pGpuhQeu0Mo04' }
];